import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { OwlOptions, SlidesOutputData, CarouselComponent } from 'ngx-owl-carousel-o';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SearchService } from '@services/search.service';
import { CreateService } from '@services/create.service';
import { ViewService } from '@services/view.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-dalbumgallery',
  templateUrl: './dalbumgallery.component.html',
  styleUrls: ['./dalbumgallery.component.sass']
})
export class DalbumgalleryComponent implements OnInit {
  @Input('response') response: object;
  @Input('gallery') gallery: object;
  @Input('position') position: number;
  @Input('albumname') name: string;
  activeSlides: SlidesOutputData;
  switcherCarousel = false;
  images: any = [];
  isLogin = false;
  comment_count = 0;
  user_id = '';
  pageCounter = 1;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    items: 1,
    nav: true
  };
  comments: any = [];
  user: any = [];
  user_src = "";
  commentForm: FormGroup;
  comment_error: any = { "description": "" };
  component = "";
  rows = 0
  user_name = "noname";
  application = "photo";
  comment_loading = true;
  params:any=[];
  btn_process = false;
  @ViewChild("owlCar") owlCar;
  @ViewChild('owlCar') carousel: CarouselComponent;
  constructor(private _viewService: ViewService, private _searchService: SearchService, private _createService: CreateService, private fb: FormBuilder, private _global: GlobalService, public _ngxSmartModalService: NgxSmartModalService) {
    this.user_id = this._global.getRandomUuid();
    this.user_name = this._global.getSessionVal('firstName');
    this.component = 'm';
    this.commentForm = this.fb.group({
      description: []
    });
    this.rows = this._global.ROWS;
  }

  ngOnChanges() {
    this.user = {
      id: this.user_id,
      name: this.user_name
    };
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
      this.user_id = this._global.getSessionVal('id');
    }
    this.user_src = this._global.generateImagePath(this.user, ['member', 'id', 'name', 's']);
    this.images = [];
    if (this.response['id']) {
      this.images = [];
      this.images = this.gallery;
      this.loadComment();
      this.switcherCarousel = true;
      this.customOptions.startPosition = '' + this.position;
      if (this.owlCar) {
        this.owlCar.to('' + this.position)
      }
    }
  }
  ngOnInit(): void {

  }
  loadComment() {
    this.comment_error = { "description": "" };
    this.comment_loading = true;
    this.comment_count = 0;
    this.comments = [];
    let pa = {
      component: this.component,
      application: 'comment',
      start: 0,
      rows: this.rows,
      mediaId: this.response['id'],
      sortOrder: 'desc',
      sortString: 'createdTime'
    };
    this._searchService.appcomment(pa).subscribe(
      commentList => {
        this.comment_loading = false;
        if (!_.isEmpty(this._global.getVal(commentList, 'response.docs', ''))) {
          this.params = this._global.getVal(commentList, 'request', {});
          this.comment_count = this._global.getVal(commentList, 'response.numFound', '0');
          this.comments = this._global.getVal(commentList, 'response.docs', {});
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScroll(){
     if (!this.comment_loading) {
       this.comment_loading = true;
       if (this.comment_count <= this.pageCounter * this.rows) {
         this.comment_loading = false;
       } else {
         let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
         p['start'] = this.pageCounter * this.rows;
         p['component'] = this.component;
         this._searchService.appcomment(p).subscribe(
           data => {
             if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
               this.comments = this.comments.concat(this._global.getVal(data, 'response.docs', []));
               this.comment_loading = false;
               this.pageCounter += 1;
               this.params = this._global.getVal(data, 'request', '');
             } else {
               this.comment_loading = false;
             }
           },
           error => {
             console.log("error", JSON.stringify(error));
           });
 
       }
      }
 
  }

  getData(data: SlidesOutputData) {
    this.pageCounter = 1;
    this.comment_loading = true;
    this.activeSlides = data;
    let sp = this.activeSlides['startPosition'];
    this.response = [];
    let o = this.gallery[sp]
    let p = {
      'component': this.component,
      'application': this.application,
      'id': o['uid']
    };
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.response = this._global.getVal(data, 'response', '');
          this.loadComment();
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  saveComment() {

    this.comment_error = { "description": "" };
    this.btn_process = true;
    let p = this.commentForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.response['name'];
    p['mediaId'] = this.response['id']
    p['application'] = 'comment';
    p['status'] = 'pending';
    p['rating'] = 0;
    p['component'] = this.component;
    p['mediaType'] = 'photo';
    this._createService.comment(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          this._global.showMessage({ "type": 'success', "message": "comment Created Success" });
          let c = this.comments;
          this.comments = [];
          this.comments.push(data["response"]);
          this.comments = this.comments.concat(c);
          this.commentForm.reset();

        } else {
          for (let key in data["errors"]) {
            this.comment_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
}
